import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PushNotificationsContext } from '../contexts/PushNotificationsContext';

export const PushNotificationRedirector = () => {
  const history = useHistory();
  const { pushNotificationJobUrl } = useContext(PushNotificationsContext);

  useEffect(() => {
    if (pushNotificationJobUrl !== null) {
      history.push(pushNotificationJobUrl);
    }
  }, [pushNotificationJobUrl]);

  return null;
};
